import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Cookies from "js-cookie";

function EditArticleModal({ isOpen, onClose, onSuccess, articleId }) {
  const [formData, setFormData] = useState({
    date: "",
    category: "",
    title: "",
    content: "",
    link: ""
  });
  const [thumbnail, setThumbnail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  // 기존 게시글 데이터 불러오기
  useEffect(() => {
    if (isOpen && articleId) {
      fetchArticleData();
    }
  }, [isOpen, articleId]);

  const fetchArticleData = useCallback(async () => {
    try {
      setInitialLoading(true);
      console.log("게시글 데이터 불러오기 시작, articleId:", articleId);

      const token = Cookies.get("token");
      const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};
      
      const response = await axios.get(`https://co77iri.com/getArticle/${articleId}`, {
        headers: authHeaders
      });
      const article = response.data;
      
      console.log("받은 게시글 데이터:", article);
      
      const formattedDate = article.created_at ? new Date(article.created_at).toISOString().split('T')[0] : "";
      console.log("변환된 날짜:", formattedDate);
      
      const newFormData = {
        date: formattedDate,
        category: article.category || "",
        title: article.title || "",
        content: article.content || "",
        link: article.link || ""
      };
      
      console.log("설정할 폼 데이터:", newFormData);
      setFormData(newFormData);
    } catch (error) {
      console.error("게시글 데이터 불러오기 실패:", error);
      alert("게시글 데이터를 불러오는데 실패했습니다.");
      onClose();
    } finally {
      setInitialLoading(false);
    }
  }, [articleId, onClose]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setThumbnail(e.target.files[0]);
  };

  // 블로그 링크에서 마지막 숫자 추출하는 함수
  const extractImageNameFromLink = (link) => {
    const match = link.match(/\/(\d+)$/);
    return match ? match[1] : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const token = Cookies.get("token");
      const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};

      // 텍스트 데이터 수정
      await axios.put(`https://co77iri.com/updateArticle/${articleId}`, {
        date: formData.date,
        category: formData.category,
        title: formData.title,
        content: formData.content,
        link: formData.link
      }, {
        headers: authHeaders
      });

      // 이미지 파일이 선택된 경우 업로드 (PNG로 변환)
      if (thumbnail) {
        const imageFileName = extractImageNameFromLink(formData.link);
        if (!imageFileName) {
          alert("블로그 링크에서 이미지 파일명을 추출할 수 없습니다. 링크 형식을 확인해주세요.");
          setLoading(false);
          return;
        }

        const imageFormData = new FormData();
        const finalFileName = `${imageFileName}.png`;
        
        // 파일명을 PNG로 지정해서 FormData에 추가
        imageFormData.append("thumbnail", thumbnail, finalFileName);
        imageFormData.append("imageKey", imageFileName);

        await axios.post("https://co77iri.com/adminAddImage", imageFormData, {
          headers: authHeaders
        });
      }

      alert("게시글이 성공적으로 수정되었습니다!");
      onSuccess();
      onClose();
    } catch (error) {
      console.error("게시글 수정 실패:", error);
      alert("게시글 수정에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  if (initialLoading) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
          <div className="flex items-center justify-center">
            <p className="text-lg">게시글 데이터를 불러오는 중...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">게시글 수정</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              날짜
            </label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleInputChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              분류
            </label>
                          <select
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                required
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">분류 선택</option>
                <option value="교육">교육</option>
                <option value="기획">기획</option>
                <option value="제작">제작</option>
                <option value="로컬">로컬</option>
              </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              제목
            </label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              내용
            </label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleInputChange}
              required
              rows="4"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              링크
            </label>
            <input
              type="url"
              name="link"
              value={formData.link}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              썸네일 이미지 (변경시에만 선택)
            </label>
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <p className="text-sm text-gray-500 mt-1">
              이미지를 변경하려면 새 이미지를 선택하세요. 선택하지 않으면 기존 이미지가 유지됩니다.
            </p>
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? "수정 중..." : "수정"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditArticleModal; 